import { IBooking, ITableDate } from 'shared-types/index';

export interface IStandbyConfirmationMsg extends IProps, IHandlers, IServices {}

interface IBaseProps {
  standbyConfirmationExpiry: string;
}

/**
 * Properties passed in from angular instantiation.
 * This can include functions/handlers that simply call back to the Angular parent component
 * and do not need to modify app state (via a service).
 */
export interface IContainerProps extends IBaseProps {
  booking: IBooking;
  selectedTime: ITableDate;
  onStandbyUpdate: (isLoading: boolean, savedBooking: IBooking, isBlocked?: boolean) => void;
  onStandbyReset: () => void;
  isAllowedToSend: boolean;
}

/**
 * Properties passed directly into the react component. If the container is responsible for fetching async data, via a
 * service, these may differ from IContainerProps.
 */
export interface IProps extends IBaseProps {
  isLoading: boolean;
  errorMsg: string;
  formattedTime: string;
  bookingExpired: boolean;
}

/**
 * Handlers used to modify app state (via a service) from within the module's container.
 * Similar to redux mapDispatchToProps.
 */
export interface IHandlers {
  handleResendClick: () => void;
  handleResetClick: () => void;
}

export interface IServices {
  EditBookingActions: any;
}

export const classPrefix = 'StandbyConfirmationMsg';
